module.exports = __webpack_public_path__ + "static/media/100-10-1-welcome5.40647d7b.jpg";